import React from 'react';
import styles from './ColorButton.module.scss';

type Props = {
  text: string;
  color: string;
  isActive: boolean;
  onClick: () => void;
};

const ColorButton: React.FC<Props> = ({ text, color, isActive, onClick }) => (
  <button
    type='button'
    style={{ background: color }}
    className={`${styles.button} ${isActive ? styles.button_active : ''}`}
    disabled={isActive}
    onClick={onClick}
  >
    <span className={styles.button__number} style={{ color }}>
      {text}
    </span>
  </button>
);

export default ColorButton;
